var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('span',{class:['spanCustom', ..._vm.cssClasses],attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }